import { CmsApiThreeSectionSliderBlockData } from 'modules/cms/api/types/CmsApiThreeSectionSlider';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpThreeSectionSliderBlock } from './CmsAmpThreeSectionSliderBlock';
import { CmsThreeSectionSliderBlock } from './CmsThreeSectionSliderBlock';

export const CmsThreeSectionSliderBlockMapping: CmsBlockMapping<CmsApiThreeSectionSliderBlockData> =
  {
    invariant: [
      {
        prop: 'headline',
        msg: 'Heading required for Three Section Slider',
      },
      {
        prop: 'sections',
        msg: 'Sections required for Three Section Slider',
      },
    ],
    width: CmsBlockWidth.INSET,
    Component: CmsThreeSectionSliderBlock,
    AmpComponent: CmsAmpThreeSectionSliderBlock,
  };
